import script from "./FinalCTASection.vue?vue&type=script&setup=true&lang=js"
export * from "./FinalCTASection.vue?vue&type=script&setup=true&lang=js"

import "./FinalCTASection.vue?vue&type=style&index=0&id=2413e70b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2413e70b"]])

export default __exports__